import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import HtmlRegion from '../htmlRegion';
import Footer from '../../../components/footer';

class BottomFooter extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { cooperation, footer } = this.props.content;

        return [
            <div key="bottomFooter" className={styles.bottomFooter}>
                <Chip id={25010} type="static" title="合作链接" groupName="合作链接" content={cooperation}>
                    <HtmlRegion className={styles.cooperation} />
                </Chip>
            </div>,
            <div key="footer" className={styles.footer}>
                <Footer content={footer} />
            </div>,
        ];
    }
}

export default BottomFooter;
